import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import useIconSizeForButtonSize from '@wix/da-ds/pkg/Buttons/hooks/useIconSizeForButtonSize';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

export interface Props {
  className?: string;
  href?: string;
  size?: ButtonSize;
  onClick?: () => void;
}

const NullIcon = () => (
  <span style={{ display: 'block', width: '1px', height: '24px' }} />
);

const NullIcon16 = () => (
  <span style={{ display: 'block', width: '1px', height: '16px' }} />
);

const DummySubscribedVariant: React.FC<Props> = ({
  className,
  size = 'medium',
  href,
  onClick,
}) => {
  const { t } = useTranslation();
  const iconSize = useIconSizeForButtonSize(size);
  const icon = iconSize === IconSize.SMALLER ? NullIcon16 : NullIcon;
  return (
    <SolidButton
      className={className}
      size={size}
      variant={'approval-green'}
      priority="secondary"
      href={href}
      icon={icon}
      onClick={onClick}
    >
      {t('deviation.tier.subscribed')}
    </SolidButton>
  );
};
DummySubscribedVariant.displayName = 'DummySubscribedVariant';

export default DummySubscribedVariant;
